import {CacheableDataObject} from '../models/CacheableDataObject.jsx'

class Stage extends CacheableDataObject
{
	generateElement(){
		let stage = $('<div>')
			.addClass('stage')
			.attr('title', this.name)
			.css('background-image', 'url('+this.image_url+')')
			.data('id', this.id)
			.data('name', this.name);
		let stageName = $('<span>').addClass('name').text(this.name);
		stage.append(stageName);
		return stage;
	}

}

export {Stage};